import { render, staticRenderFns } from "./selectSuspension.vue?vue&type=template&id=3399e023&scoped=true&"
import script from "./selectSuspension.vue?vue&type=script&lang=js&"
export * from "./selectSuspension.vue?vue&type=script&lang=js&"
import style0 from "./selectSuspension.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3399e023",
  null
  
)

export default component.exports